import React, { forwardRef, useCallback, useMemo } from 'react'
import { useHref, useLinkClickHandler } from 'react-router-dom'
import { Tooltip, Typography } from 'antd'
import { isString, size } from 'lodash'
import PropTypes from 'prop-types'

const TEXT_SIZE_LIMIT = 30

const TypographyLinkWrapper = forwardRef(
  (
    {
      to,
      disabled,
      state,
      replace,
      strong,
      target,
      children,
      onClick,
      ...rest
    },
    ref,
  ) => {
    const href = useHref(to)

    const handleClick = useLinkClickHandler(to, {
      replace,
      state,
      target,
    })

    const isTextInEllipsis = useMemo(
      () => isString(children) && size(children) > TEXT_SIZE_LIMIT,
      [children],
    )

    const navigate = useCallback(
      event => {
        onClick?.(event)
        if (!event.defaultPrevented) {
          handleClick(event)
        }
      },
      [handleClick, onClick],
    )

    return (
      <Tooltip title={isTextInEllipsis ? children : undefined}>
        {!disabled ? (
          <Typography.Link
            {...rest}
            strong={strong}
            ellipsis
            href={href}
            target={target}
            ref={ref}
            onClick={navigate}
          >
            {children}
          </Typography.Link>
        ) : (
          <Typography.Text {...rest} strong={strong} ellipsis ref={ref}>
            {children}
          </Typography.Text>
        )}
      </Tooltip>
    )
  },
)

TypographyLinkWrapper.propTypes = {
  to: PropTypes.string.isRequired,
  state: PropTypes.object,
  replace: PropTypes.bool,
  strong: PropTypes.bool,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

TypographyLinkWrapper.defaultProps = {
  disabled: false,
  strong: false,
  target: undefined,
  state: undefined,
  replace: false,
  onClick: undefined,
}

export default TypographyLinkWrapper
